import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-totales',
  templateUrl: './totales.component.html',
  styleUrls: ['./totales.component.css']
})
export class TotalesComponent implements OnInit {

  identity: any = {};
  actAport: Boolean = false
  actAhorr: Boolean = false
  actCart: Boolean = false
  actServ: Boolean = false
  parametros: any
  data: any
  valor: number
  SaldosTotales: any 
  aportes: any
  ahorros: any
  cartera: any
  servicios: any
  total: any
  actual = environment.actual;
  public colorFondo = environment.entidad[this.actual].colorMenu;
  public letraColor = environment.entidad[this.actual].letraColor;

  constructor(private spinner: NgxSpinnerService,
    private _userService: UserService) { }

  ngOnInit(): void {
    this.spinner.show()
    this.identity = JSON.parse(this._userService.GetsessionStorage('identity'));
    this.parametros = JSON.parse(this._userService.GetsessionStorage('parametrosGenerales'));
    const date = new Date();
    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();
    this.data = {
      codasociado: this.identity.CODASOCIADO,
      fhasta: year + '-' + (monthIndex + 1) + '-' + day,
      recoge: false
    };

    for (let i = 0; i < this.parametros.length; i++) {
      if (this.parametros[i].parametro == 'inicio' && this.actual != 'fsv') {
        this.actAport = true
      }
      if (this.parametros[i].parametro == 'Ahorros') {
        this.actAhorr = true
      }
      if (this.parametros[i].parametro == 'Cartera') {
        this.actCart = true
      }
      if (this.parametros[i].parametro == 'Servicios') {
        this.actServ = true
      }
    }

    this.cargaAhorros()
  }

  cargaAhorros() {
    this._userService.httpPost('ahorros', this.data).subscribe(resp => {
      this.ahorros = resp.details
      this.cargaCartera()
    })
  }

  cargaCartera() {
    this._userService.httpPost('cartera', this.data).subscribe(resp => {
      this.cartera = resp.details
      this.cargaServicios()
    })
  }

  cargaServicios() {
    this._userService.httpPost('servicios', this.data).subscribe(resp => {
      this.servicios = resp.details
      this.listarInformacion()
    })
  }

  listarInformacion() {
    let date = new Date();
    var ultimoDia = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    this.SaldosTotales = []
    this.total = 0;
    let d

    let saldo = 0

    if (this.actAport) {
      this.SaldosTotales.push({ descripcion: 'Aportes', valor: this.identity.APORTE })
      saldo = parseInt(this.identity.APORTE )
      this.total = this.total + saldo;
    }
    saldo = 0


    if (this.actAhorr) {
    /*  for (let i = 0; i < this.ahorros.length; i++) {
        if (this.ahorros[i].DESCRIPCION.trim() != 'TOTALES') {
          d = this.ahorros[i].FHAPROXPAGO
          if (d.toString().indexOf(' ')) {
            let valor = d.split(' ');
            d = valor[0];
          }
          if (d.toString().indexOf('T')) {
            let valor = d.split('T');
            d = valor[0];
          }
          d = new Date(d + ' 11:00')
          d = d.toISOString()
          let day = new Date(d)        
          if(day.getMonth()+1 == ultimoDia.getMonth()+1){
            saldo = saldo + this.ahorros[i].CUOTA
          }
        }
      }

      this.SaldosTotales.push({ descripcion: 'Ahorros', valor: this.ahorros[i].CUOTA })
      this.total = this.total + this.ahorros[i].CUOTA*/
    }

    saldo = 0

    if (this.actCart) {
      for (let i = 0; i < this.cartera.length; i++) {
        if (this.cartera[i].LINEA.trim() != 'TOTALES') {
          d = this.cartera[i].FHAPROXPAGO
          if (d.toString().indexOf(' ')) {
            let valor = d.split(' ');
            d = valor[0];
          }
          if (d.toString().indexOf('T')) {
            let valor = d.split('T');
            d = valor[0];
          }
          d = new Date(d + ' 11:00')
          d = d.toISOString()
          let day = new Date(d)        
          if(day.getMonth()+1 <= ultimoDia.getMonth()+1){
            saldo = saldo + this.cartera[i].CUOTA
          }
        }
      }
      this.SaldosTotales.push({ descripcion: 'Cartera', valor: saldo })
      this.total = this.total + saldo
    }

    saldo = 0

    if (this.actServ) {
      for (let i = 0; i < this.servicios.length; i++) {
        if (this.servicios[i].LINEA.trim() != 'TOTALES') {
          d = this.servicios[i].FHAPROXPAGO
          if (d.toString().indexOf(' ')) {
            let valor = d.split(' ');
            d = valor[0];
          }
          if (d.toString().indexOf('T')) {
            let valor = d.split('T');
            d = valor[0];
          }
          d = new Date(d + ' 11:00')
          d = d.toISOString()
          let day = new Date(d)        
          if(day.getMonth()+1 == ultimoDia.getMonth()+1){
            saldo = saldo + this.servicios[i].CUOTA
          }
        }
      }
      this.SaldosTotales.push({ descripcion: 'Servicios', valor: saldo })
      this.total = this.total + saldo 
    }

    this.spinner.hide()
  }

}
